import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import ManageSalaries from '../views/ManageSalaries.vue'
import index from '../components/index.vue'
import Container from '../views/Container.vue'
import Welcome from '../views/Welcome.vue'
import CtrlCVtoexcel from '../views/CtrlCVtoexcel.vue'
import Recovery from '../views/Recovery.vue'
import Profile from '../views/Profile.vue'
import CourseInformationOperation from '../views/CourseInformationOperation.vue'
import UserManager from '../views/UserManager.vue'
import CourseManager from '../views/CourseManager.vue'
import SysMaint from '../views/SysMaint.vue'



Vue.use(VueRouter)

const routes: Array<RouteConfig> = [

  {
    path: '/',
    name: 'index',
    // component: SysMaint
     component: index
  },
  {
    path: '/Container',
    name: 'Container',
    component: Container,
    redirect: '/Welcome',
    children: [
      { path: '/Profile', name: 'Profile', component: Profile },
      { path: '/Welcome', name: '操作页面', component: Welcome },
      { path: '/ManageSalaries', name: '管理工资页面', component: ManageSalaries },
      { path: '/CtrlCVtoexcel', name: '支付宝批量付款', component: CtrlCVtoexcel },
      { path: '/Recovery', name: '删除的课节', component: Recovery },
      { path: '/CourseInformationOperation/:id', name: '课程信息操作', component: CourseInformationOperation },
      { path: '/UserManager', name: '教务管理', component: UserManager },
      { path: '/CourseManager', name: '课程管理', component: CourseManager }
    ]
  },
  {
    path: '/**',
    name: 'index',
    component: index
  },
]

const router = new VueRouter({
  routes
})
export default router
